import * as React from "react";

function SvgResetZoom(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 48 48" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.044 42C40 43.8 44 40 42 38.016c-2-1.984-9.007-9.073-9.007-9.073S32.05 30.443 31 31.5c-1.047 1.058-1.964 1.428-1.964 1.428S36.087 40.2 38.044 42z"
        fill="#fff"
      />
      <path
        d="M34 19.5c0 7.84-6.223 14.228-14 14.492v-4.004c5.567-.26 10-4.857 10-10.488C30 13.701 25.299 9 19.5 9 13.869 9 9.273 13.433 9.012 19H12l-5 8-5-8h3.008C5.272 11.223 11.66 5 19.5 5 27.508 5 34 11.492 34 19.5z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgResetZoom;
